import type { MediaDto } from '@/lib/sanity/dto';
import { UiImage } from '@/components/ui/UiImage';
import { VEHICLE_IMAGE_SIZES } from '@/features/vehicle';
import { cn } from '@/lib/utils/tw-merge';

type VehicleGalleryPhotoProps = {
    image: MediaDto;
    alt: string;
    /** Until the photo is in, the thumbnail's file stands in, blurred — the strip has loaded it already. */
    placeholder: boolean;
    onLoad: () => void;
    /** The viewer letterboxes the photo; the page's stage crops it. */
    contain?: boolean;
    /** The page's LCP element. */
    lcp?: boolean;
};

/**
 * A photo on a gallery stage. The page and the viewer request the same file:
 * whichever loads it first, the other finds it in the cache — and the DMS photos
 * are only 1280px wide, so a full-screen candidate would add little.
 */
export function VehicleGalleryPhoto({
    image,
    alt,
    placeholder,
    onLoad,
    contain = false,
    lcp = false,
}: VehicleGalleryPhotoProps) {
    const fit = contain ? 'object-contain' : undefined;

    return (
        <>
            {placeholder ? (
                <UiImage
                    image={image}
                    sizes={VEHICLE_IMAGE_SIZES.thumb}
                    alt=""
                    loading="eager"
                    className={cn('vehicle-gallery__placeholder', fit)}
                />
            ) : null}
            <UiImage
                image={image}
                sizes={VEHICLE_IMAGE_SIZES.gallery}
                alt={alt}
                loading="eager"
                fetchPriority={lcp ? 'high' : undefined}
                className={fit}
                onLoad={onLoad}
            />
        </>
    );
}
